import { createContext } from "react";

export const AppContext = createContext({
  file: {},
  setFile: () => {},
  info: {},
  setInfo: () => {},
  notification: {},
  setNotification: () => {},
  loader: {},
  setLoader: () => {},
  grid: {},
  setGrid: () => {},
  table: {},
  setTable: () => {},
});
